import React from "react";
import { useNavigate } from "react-router-dom";
import "./Styles/Job-Buttons.css";

export default function JobButtons({
                                                  showPrevious = true,
                                                  showPreview = false,
                                                  showNext = true,
                                                  onPrevious,
                                                  onContinue,
                                                  onPreview,
                                                  previewText = " ",
                                                  continueText = " ",
                                                  previousPath,
                                                  continueType = "button",
                                              }) {
    const navigate = useNavigate();

    return (
        <div className="job-create-buttons">
            {showPrevious ? (
                <button
                    type="button"
                    className="job-create-previous-button"
                    onClick={() => {
                        if (previousPath) {
                            navigate(previousPath);
                        } else if (typeof continueType === "function" && !showPrevious) {
                            onPrevious();
                        } else if (typeof onPrevious === "function" ) {
                            onPrevious();
                        } else {
                            navigate(-1);
                        }
                    }}
                >
                    Previous
                </button>
            ) : (
                <div style={{ flex: 1 }} /> // takes left space
            )}

            <div className="job-create-right-buttons">
                {showPreview && (
                    <button
                        type="button"
                        className="job-create-preview-button"
                        onClick={onPreview}
                    >
                        {previewText}
                    </button>
                )}

                {showNext && (
                    <button
                        type={continueType}
                        className="job-create-submit-button"
                        onClick={onContinue}
                    >
                        {continueText}
                    </button>
                )}
            </div>
        </div>
    );
}
